<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>论文详情</el-breadcrumb-item>
          </el-breadcrumb>
          <el-row class="type-opr">
            <el-col :span="24" style="text-align: right">
              <span class="span-num">下载量：{{irStaticDiss.downloadNum}}</span>
              <span class="span-num">浏览量：{{irStaticDiss.scanNum}}</span>
              <el-button
                type="primary"
                size="medium"
                plain
                icon="el-icon-bottom"
                @click="changDown"
              >全文下载</el-button>
            </el-col>
          </el-row>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix" style="text-align: center;">
              <span>{{irStaticDiss.title}}</span>
            </div>
            <div class="talent-info">
              <p>
                <b>论文名称：</b>
                {{irStaticDiss.title}}
              </p>
              <p>
                <b>文献作者：</b>
                {{irStaticDiss.author}}
              </p>
              <p>
                <b>通讯作者：</b>
                {{irStaticDiss.coAuthors}}
              </p>
              <p>
                <b>所属部门：</b>
                {{irStaticDiss.deptName}}
              </p>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <span>论文详情</span>
            </div>
            <div class="talent-info">
              <p>
                <b>收录情况：</b>
                {{irStaticDiss.includeInfo}}
              </p>
              <p>
                <b>年：</b>
                {{irStaticDiss.year}}
              </p>
              <p>
                <b>卷：</b>
                {{irStaticDiss.njqName}}
              </p>
              <p>
                <b>期：</b>
                {{irStaticDiss.issn}}
              </p>
              <p>
                <b>页(文献号)：</b>
                {{irStaticDiss.page}}
              </p>
              <p>
                <b>摘要：</b>
                {{irStaticDiss.summary}}
              </p>
              <p>
                <b>关键词：</b>
                {{irStaticDiss.keywords}}
              </p>
              <p>
                <b>刊名：</b>
                {{irStaticDiss.journalName}}
              </p>
              <p>
                <b>PMID：</b>
                {{irStaticDiss.issn}}
              </p>
              <p>
                <b>doi：</b>
                {{irStaticDiss.subjectCode}}
              </p>
              <p>
                <b>基金：</b>
                {{irStaticDiss.amountMoney}}
              </p>
              <p>
                <b>备注：</b>
                {{irStaticDiss.unitsubjectCode}}
              </p>
            </div>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'left',
  components: {
    centerLeft,
  },
  data() {
    return {
      irStaticDiss: {},
    }
  },
  methods: {
    getDetails(userId) {
      let currThis = this
      axios({
        method: 'get',
        url:
          '/api/member/toDeatil/' +
          this.$route.query.id +
          '/' +
          userId +
          '/finish',
      })
        .then(function (response) {
          console.log(response)
          currThis.irStaticDiss = response.data.data.irStaticDiss
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    changDown() {
      let currThis = this
      axios({
        method: 'post',
        url: '/api/Achieve/changeDownNum/' + this.$route.query.id,
      })
        .then(function (response) {
          console.log(response)
          currThis.irStaticDiss.downloadNum =
            currThis.irStaticDiss.downloadNum + 1
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
  },
  mounted() {
    this.userId = this.$cookies.get('rtnVal')
    this.getDetails(this.userId)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/view.vue